import React, { useEffect, useState } from 'react';
import axios from 'axios';

const ScrollingCategoryBanner = ({ inquiry = false }) => {
  const [mainCat, setMainCat] = useState([]);

  const getMainCat = async () => {
    const data = new FormData();
    data.append('uid', 'ss');
    if (!inquiry) data.append('status', 'enable');

    try {
      const response = await axios.post('/pro/cat/maincat.php', data, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      const result = response.data;
      setMainCat(Array.isArray(result) ? result : []);
    } catch {
      setMainCat([]);
    }
  };

  useEffect(() => {
    getMainCat();
  }, []);

  if (mainCat.length === 0) return null;

  const categoryTitles = mainCat
    .map((cat) => (
      `<i class="fas ${cat.icon}" style="margin-right: 5px;"></i>${cat.title}`
    ))
    .join(', ');

  return (
    <div className="banner-container" style={{
      overflow: "hidden",
    }}>
      <div
        className="banner-track"
        dangerouslySetInnerHTML={{
          __html: `Currently We Are Dealing in These Categories – ${categoryTitles}`
        }}
      />
    </div>
  );
};

export default ScrollingCategoryBanner;
